import { useQuery } from "@tanstack/react-query";
import { createFileRoute, useParams, useSearch } from "@tanstack/react-router";
import { ticketQueryOptions } from "@/services/ticket/ticket.options";
import { AdminTicketTypeFullIndexTabContent } from "./AdminTicketTypeFullPage";

const FULL_INDEX =
	"/_authenticated/(admin-app)/_admin/admin/configuration/ticketTypes/$ticketTypeId/full/" as const;

const FULL_PARENT =
	"/_authenticated/(admin-app)/_admin/admin/configuration/ticketTypes/$ticketTypeId/full" as const;

export const Route = createFileRoute(FULL_INDEX)({
	component: AdminTicketTypeFullIndexRoute,
});

function AdminTicketTypeFullIndexRoute() {
	const params = useParams({ from: FULL_PARENT });
	const search = useSearch({ from: FULL_PARENT });

	const detailQuery = useQuery(
		ticketQueryOptions.ticketTypeDetail(params.ticketTypeId),
	);

	const ticketType = detailQuery.data ?? null;

	if (!ticketType) {
		return null;
	}

	return (
		<AdminTicketTypeFullIndexTabContent
			tab={search.tab}
			ticketType={ticketType}
		/>
	);
}
